export default __webpack_public_path__ + "static/media/virusred-250-min.a67f86ef.png";